import React, { Component } from 'react';
import { MultiSelect, ComboBox } from '@progress/kendo-react-dropdowns';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { getRegionsIntegrated, getcustomersIntegrated, getPracticeTypesIntegrated, getBillingDiviIntegrated } from '../../integration/MasterDataService';
import { getAllDesignations } from "../../masterData/designation/DesignationService";
import { getProjectResources } from '../../resourceManagement/ResourceService';
import { getProjectsAndCrData, searchDeliveryTrackerRecords } from './ResourceUtilizationService';
import { getPaymentMethods, getProjectTypes } from '../../masterData/common/CommonService';
import { formatNumber } from '../../integration/CommonUtils';
import DeliveryTrackerExcel from './DeliveryTrackerExcel';
import Loader from '../../integration/components/Loader';
import moment from 'moment';
import 'moment-timezone';import { LOG_TYPES } from "../../integration/IntegrationEnums";
import * as loggerService from "../../integration/LoggerService";
import { saveAuditTrail } from '../../integration/auditTrail/AuditTrailService';

class DeliveryTracker extends Component {
    _export;

    isMount = false;

    constructor(props) {
        super(props);

        this.state = {
            projectAndCRs: [],
            projectAndCRsAll: [],
            selectedProjectName: [],
            region: [],
            regionAll: [],
            selectedRegion: null,
            validRegions: [],
            customers: [],
            customersAll: [],
            selectedCustomer: [],
            resPractice: [],
            resPracticeAll: [],
            selectedResPractice: [],
            practice: [],
            practiceAll: [],
            projectRoles: [],
            projectRolesAll: [],
            selectedProjectRole: [],
            selectedPractice: [],
            resources: [],
            resourcesAll: [],
            selectedResource: [],
            startDate: null,
            endDate: null,
            projectTypes: [],
            projectTypesAll: [],
            selectedProjectType: [],
            paymentMethods: [],
            paymentMethodsAll: [],
            selectedPaymentMethod: [],
            projectDepartments: [],
            projectDepartmentsAll: [],
            selectedProjectDepartments: [],
            deliveryTrackerData: [],
            projectMarginsExcel: [],
            deliveryTrackerDataExcel: [],
            plannedRevenueTotalUSD: 0,
            invoicedRevenueTotalUSD: 0,
            timesheetRevenueTotalUSD: 0,
            plannedTotalEffort: 0,
            invoicedTotalEffort: 0,
            timesheetTotalEffort: 0,
            plannedRevenueTotalPC: 0,
            invoicedRevenueTotalPC: 0,
            timesheetRevenueTotalPC: 0,
            reportDate: null,
            excelDownload: false,
            userRoleAllowed: false,
            skip: 0,
            take: 20,
            sort: [
                { field: 'updatedAt', dir: 'desc' }
            ],
            loading: false
        };
    }

    componentDidMount() {
        this.isMount = true;
        this.props.onHeaderTitleChange('Delivery Tracker');
        this.setInitialData();
    }

    setInitialData = async() => {
        await this.setState({
            loading: true
        });
        await this.populateRegions();
        await this.populatePractices();
        await this.validateRegions();
        await this.populateCustomers();
        await this.getAllActiveResources();
        await this.populateProjectRoles();
        await this.populateProjectTypes();
        await this.populatePaymentMethods();
        await this.populateDepartments();
        await this.populateAllProjectsData();
        await this.onInitialDateValues();
        await this.onSaveAuditTrail();
        await this.setState({
            loading: false
        });
    }

    componentWillUnmount() {
        this.isMount = false;
    }

    onSaveAuditTrail = () => {
        if (this.isMount) {
            const auditTrail = {
                Action: 'Delivery Tracker viewed',
                RefType: 'Delivery Tracker',
                RefId: window.LOGGED_USER.user,
                RefName: window.LOGGED_USER.displayName
            }
            saveAuditTrail(auditTrail)
        }
    }

    onInitialDateValues = async() => {
        const firstDateOfMonth = new Date().setDate(1);
        const lastDateOfMonth = moment(new Date()).endOf('month');
        if (this.isMount) {
            await this.setState({
                startDate: new Date(firstDateOfMonth),
                endDate: new Date(lastDateOfMonth),
            });
        }
    }

    validateRegions = async() => {
        let validRegions = [];
        const userPermissions = window.USER_PERMISSION;

        const globalPermission= userPermissions.some(obj => obj === 'GLOBAL_DEL_TRACKER');
        if (globalPermission) {
            await this.setState({
                userRoleAllowed: true
            });
        } else {
            const asiaPermission= userPermissions.some(obj => obj === 'AMEA_DEL_TRACKER');
            if (asiaPermission) {
                const asiaRegios = this.state.regionAll.filter(x => x.id === 3 || x.id === 5 || x.id === 18 || x.id === 19);
                validRegions = validRegions.concat(asiaRegios);
            }
    
            const anzPermission = userPermissions.some(obj => obj === 'ANZ_DEL_TRACKER');
            if (anzPermission) {
                const anzRegios = this.state.regionAll.filter(x => x.id === 4);
                validRegions = validRegions.concat(anzRegios);
            }
    
            const ukPermission = userPermissions.some(obj => obj === 'UK_EUR_DEL_TRACKER');
            if (ukPermission) {
                const ukRegios = this.state.regionAll.filter(x => x.id === 1 ||  x.id === 21);
                validRegions = validRegions.concat(ukRegios);
            }
    
            const usPermission = userPermissions.some(obj => obj === 'AMERICAS_DEL_TRACKER');
            if (usPermission) {
                const usRegios = this.state.regionAll.filter(x => x.id === 2);
                validRegions = validRegions.concat(usRegios);
            }
    
            if (validRegions && validRegions.length > 0) {
                await this.setState({
                    region: validRegions,
                    validRegions: validRegions,
                    selectedRegion: validRegions[0]
                });
            }    
        }
    };

    populateRegions = async() => {
        await getRegionsIntegrated()
            .then(res => {
            if (this.isMount) {
                this.setState({
                    region: res.data,
                    regionAll: res.data
                });
            }
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };

    populateAllProjectsData = async() => {
        const fields = {};
        fields.AllAccess = this.state.userRoleAllowed;
        fields.ValidRegions = this.state.validRegions.map(value => value.id);;
        await getProjectsAndCrData(fields)
            .then(res => {  
                if (this.isMount) {
                    this.setState({
                    projectAndCRs: res.data,
                    projectAndCRsAll: res.data,
                    });
                }
            })
            .catch(error => {
                loggerService.writeLog(error, LOG_TYPES.ERROR);
            });
    };
    
    populateCustomers = async() => {
        await getcustomersIntegrated()
            .then(res => {
                if (this.isMount) {
                this.setState({
                    customers: res.data,
                    customersAll: res.data
                });
                }
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };

    populatePractices = async () => {
        await getPracticeTypesIntegrated()
        .then(res => {
            this.setState({
                resPractice: res.data,
                resPracticeAll: res.data,
            });
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    }

    getAllActiveResources = async () => {
        await getProjectResources() 
        .then(async res => {
            await this.setState({
                resources: res.data,
                resourcesAll: res.data,
            });
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };

      populateProjectRoles = async () => {
        await getAllDesignations()
          .then(res => {
            if (this.isMount) {
              this.setState({
                projectRoles: res.data,
                projectRolesAll: res.data,
              });
            }
          })
          .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
          });
      };

    populateProjectTypes = async() => {
        await getProjectTypes()
        .then(res => {
            if (this.isMount) {
                this.setState({
                    projectTypes: res.data,
                    projectTypesAll: res.data
                });
            }
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };

    populatePaymentMethods = async() => {
        await getPaymentMethods()
            .then(res => {
            if (this.isMount) {
                this.setState({
                    paymentMethods: res.data,
                    paymentMethodsAll: res.data
                });
            }
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };

    populateDepartments = async() => {
        await getBillingDiviIntegrated()
        .then(res => { 
            if (this.isMount) {
                this.setState({
                    projectDepartments: res.data,
                    projectDepartmentsAll: res.data
                });
            }
        })
        .catch(error => {
            loggerService.writeLog(error, LOG_TYPES.ERROR);
        });
    };
    
    
    filterData(filter, allData) {
        const data = allData.slice();
        return filterBy(data, filter);
    }

    filterChangeProjectName = event => {
        if (this.isMount) {
            this.setState({
                projectAndCRs: this.filterData(event.filter, this.state.projectAndCRsAll)
            });
        }
    };

    filterChangeRegion = event => {
        if (this.isMount) {
            this.setState({
                region: this.filterData(event.filter, this.state.regionAll)
            });
        }
    };

    filterChangeCustomer = event => {
        if (this.isMount) {
            this.setState({
                customers: this.filterData(event.filter, this.state.customersAll)
            });
        }
    };

    filterChangePractice = event => {
        if (this.isMount) {
            this.setState({
                resPractice: this.filterData(event.filter, this.state.resPracticeAll)
            });
        }
    };

    filterResources = event => {
        if (this.isMount) {
            this.setState({
                resources: this.filterData(event.filter, this.state.resourcesAll)
            });
        }
    };

    filterProjectRole = event => {
        if (this.isMount) {
            this.setState({
                projectRoles: this.filterData(event.filter, this.state.projectRolesAll)
            });
        }
    };

    filterProjectDepartments = event => {
        if (this.isMount) {
            this.setState({
                projectDepartments: this.filterData(event.filter, this.state.projectDepartmentsAll)
            });
        }
    };

    filterProjectTypes = event => {
        if (this.isMount) {
            this.setState({
                projectTypes: this.filterData(event.filter, this.state.projectTypesAll)
            });
        }
    };

    filterPaymentMethod = event => {
        if (this.isMount) {
            this.setState({
                paymentMethods: this.filterData(event.filter, this.state.paymentMethodsAll)
            });
        }
    };

    handleInputChange = event => {
        const valueObj = event.target.value;
        const field = event.target.name;
        if (this.isMount) {
            this.setState({
                [field]: valueObj
            });
        }
    };

    handleStartDateChange = event => {
        let startDate = event.target.value;
        if (this.isMount) {
            this.setState({
                startDate: new Date(startDate),
            });
        }
    };
    
    handleEndDateChange = event => {
        const endDate = event.target.value;
        if (this.isMount) {
            this.setState({
                endDate: new Date(endDate),
            });
        }
    };

    pageChange = event => {
        if (this.isMount) {
            this.setState({
                skip: event.page.skip,
                take: event.page.take
            });
        }
    };

    submitSearch = async(event) => {
        if (event) {
            event.preventDefault();
            this.setState({
                skip: 0,
                take: 20
            });        
        } 

        if (this.isMount) {
            await this.setState({
                loading: true
            });
        }

        if (this.state.startDate && this.state.endDate) {

            const fields = {
                selectedProjects: this.state.selectedProjectName && this.state.selectedProjectName.length > 0 ? this.state.selectedProjectName : this.state.projectAndCRsAll,
                selectedRegion: this.state.selectedRegion ? this.state.selectedRegion : null,
                selectedCustomer: this.state.selectedCustomer,
                selectedResPractice: this.state.selectedResPractice,
                selectedResource: this.state.selectedResource,
                selectedProjectRole: this.state.selectedProjectRole,
                selectedProjectType: this.state.selectedProjectType,
                selectedPaymentMethod: this.state.selectedPaymentMethod,
                selectedProjectDepartments: this.state.selectedProjectDepartments,
                StartDate: moment(this.state.startDate).format('YYYY-MM-DD'),
                EndDate: moment(this.state.endDate).format('YYYY-MM-DD'),
            };

            fields.count = 0;
            fields.skip = event ? 0 : this.state.skip;
            fields.take = event ? 20 : this.state.take;
            fields.sort = event || this.state.sort.length === 0 ? [{ field: 'updatedAt', dir: 'desc' }] : this.state.sort;

            if (fields.selectedProjects && fields.selectedProjects.length > 0) {
                await searchDeliveryTrackerRecords(fields)
                .then(res => {
                    if (this.isMount) {
                        this.setState({
                            deliveryTrackerData: res.data.DeliveryTrackerRecords,
                            plannedRevenueTotalUSD: res.data.PlannedRevenueTotalUSD,
                            invoicedRevenueTotalUSD: res.data.InvoicedRevenueTotalUSD,
                            timesheetRevenueTotalUSD: res.data.TimesheetRevenueTotalUSD,
                            plannedTotalEffort: res.data.PlannedTotalEffort,
                            invoicedTotalEffort: res.data.InvoicedTotalEffort,
                            timesheetTotalEffort: res.data.TimesheetTotalEffort,
                            plannedRevenueTotalPC: res.data.PlannedRevenueTotalPC,
                            invoicedRevenueTotalPC: res.data.InvoicedRevenueTotalPC,
                            timesheetRevenueTotalPC: res.data.TimesheetRevenueTotalPC,
                            loading: false,
                        });
                    }
                })
                .catch(error => {
                    loggerService.writeLog(error, LOG_TYPES.ERROR);
                });
            }
        }
           
        await this.setState({
            loading: false,
        });
    }

    exportExcel = async (event) => {
        await this.setState({
            loading: true
        });  
        if (this.state.startDate && this.state.endDate) {

            const fields = {
                selectedProjects: this.state.selectedProjectName && this.state.selectedProjectName.length > 0 ? this.state.selectedProjectName : this.state.projectAndCRsAll,
                selectedRegion: this.state.selectedRegion ? this.state.selectedRegion : null,
                selectedCustomer: this.state.selectedCustomer,
                selectedResPractice: this.state.selectedResPractice,
                selectedResource: this.state.selectedResource,
                selectedProjectRole: this.state.selectedProjectRole,
                selectedProjectType: this.state.selectedProjectType,
                selectedPaymentMethod: this.state.selectedPaymentMethod,
                selectedProjectDepartments: this.state.selectedProjectDepartments,
                StartDate: moment(this.state.startDate).format('YYYY-MM-DD'),
                EndDate: moment(this.state.endDate).format('YYYY-MM-DD'),
            };

            if (fields.selectedProjects && fields.selectedProjects.length > 0) {
                await searchDeliveryTrackerRecords(fields)
                .then(res => {
                    if (this.isMount) {
                        this.setState({
                            deliveryTrackerDataExcel: res.data,
                            loading: false,
                            reportDate: moment(new Date()).format('YYYY-MM-DD'),
                            excelDownload: true
                        });
                    }
                })
                .catch(error => {
                    loggerService.writeLog(error, LOG_TYPES.ERROR);
                });
            }
        }
        await this.setState({
            loading: false,
        });
    }

    customCell = (props) => {
        const value = props.dataItem[props.field];
        const roundedValue = value !== null && value !== undefined 
            ? formatNumber(Number(value))
            : '';         
        return <td className="profitability-grid-text-align">{roundedValue}</td>;
    }

    customCellPct = (props) => {
        const value = props.dataItem[props.field];
        const roundedValue = value !== null && value !== undefined 
            ? formatNumber(Number(value)) + "%"
            : '';         
        return <td className="profitability-grid-text-align">{roundedValue}</td>;
    }

    cancelSearch = event => {
        event.preventDefault();
        if (this.isMount) {
            this.setState({
                selectedProjectName: [],
                selectedRegion: [],
                selectedCustomer: [],
                selectedProjectDepartments: [],
                selectedProjectType: [],
                selectedPaymentMethod: [],
                selectedResPractice: null,
                selectedResource: null,
                selectedProjectRole: []
            });
        }    
    };

    render() {
        return (
            <div className="main-card">
                <div className="row">
                    <div className="col-md-8">
                        <div className="main-heading">Delivery Tracker</div>
                    </div>
                </div>
                <form onSubmit={this.submitSearch}>
                
                    <div className="row">

                        <div className="col-md-2">
                            <div className="d-block">
                                <div className=""><label>Region:</label></div>
                            </div>
                            <div className="d-block">
                                <div className="">
                                <ComboBox
                                    className="text-break"
                                    name="selectedRegion"
                                    textField="Name"
                                    value={this.state.selectedRegion}
                                    data={this.state.region}
                                    placeholder={'Please Select'}
                                    filterable={true}
                                    onFilterChange={this.filterChangeRegion}
                                    onChange={this.handleInputChange} 
                                />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="d-block">
                                <div className=""><label>Project Name:</label></div>
                            </div>
                            <div className="d-block">
                                <div className="">
                                <MultiSelect
                                    className="text-break"
                                    name="selectedProjectName"
                                    textField="DisplayName"
                                    value={this.state.selectedProjectName}
                                    data={this.state.projectAndCRs}
                                    placeholder={'Please Select'}
                                    filterable={true}
                                    onFilterChange={this.filterChangeProjectName}
                                    onChange={this.handleInputChange} 
                                />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="d-block">
                                <div className=""><label>Customer:</label></div>
                            </div>
                            <div className="d-block">
                                <div className="">
                                <MultiSelect
                                    name="selectedCustomer"
                                    textField="Name"
                                    value={this.state.selectedCustomer}
                                    data={this.state.customers}
                                    placeholder={'Please Select'}
                                    filterable={true}
                                    onFilterChange={this.filterChangeCustomer}
                                    onChange={this.handleInputChange}
                                />   
                                </div>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="d-block">
                                <div className=""><label>Resource:</label></div>
                            </div>
                            <div className="d-block">
                                <div className="">
                                <MultiSelect
                                    className="text-break"
                                    data={this.state.resources}
                                    name="selectedResource"
                                    textField="Name"
                                    placeholder={'Please Select'}
                                    onChange={this.handleInputChange}
                                    value={this.state.selectedResource}
                                    filterable={true}
                                    onFilterChange={this.filterResources}
                                />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="d-block">
                                <div className=""><label>Resource Practice:</label></div>
                            </div>
                            <div className="d-block">
                                <div className="">
                                <MultiSelect
                                    name="selectedResPractice"
                                    textField="Name"
                                    value={this.state.selectedResPractice}
                                    data={this.state.resPractice}
                                    placeholder={'Please Select'}
                                    filterable={true}
                                    onFilterChange={this.filterChangePractice}
                                    onChange={this.handleInputChange}
                                />   
                                </div>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="d-block">
                                <div className=""><label>Project Role:</label></div>
                            </div>
                            <div className="d-block">
                                <div className="">
                                <MultiSelect
                                    className="text-break"
                                    data={this.state.projectRoles}
                                    name="selectedProjectRole"
                                    textField="Name"
                                    placeholder={'Please Select'}
                                    onChange={this.handleInputChange}
                                    value={this.state.selectedProjectRole}
                                    filterable={true}
                                    onFilterChange={this.filterProjectRole}
                                />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-2">
                            <div className="d-block">
                                <label htmlFor="">Date Range: From: </label>
                            </div>
                            <div className="d-block">
                            <div className="title-remove">
                                <DatePicker
                                    format="MM/dd/yyyy"
                                    width="100"
                                    name="startDate"
                                    onChange={this.handleStartDateChange}
                                    value={this.state.startDate}
                                    min={new Date("2020-01-01")}
                                    formatPlaceholder={{ year: 'YYYY', month: 'MM', day: 'DD' }}
                                />
                            </div>
                            </div>
                        </div>
                        
                        <div className="col-md-2">
                            <div className="d-block">
                                <label htmlFor="">To:</label>
                            </div>
                            <div className="d-block">
                            <div className="title-remove">
                                <DatePicker
                                    format="MM/dd/yyyy"
                                    width="100"
                                    name="endDate"
                                    onChange={this.handleEndDateChange}
                                    value={this.state.endDate}
                                    min={this.state.startDate ? new Date(this.state.startDate) : new Date("2020-01-01")}
                                    formatPlaceholder={{ year: 'YYYY', month: 'MM', day: 'DD' }}
                                />
                            </div>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="d-block">
                                <label>Project Department:</label>
                            </div>
                            <div className="d-block">
                                <div className="">
                                    <MultiSelect
                                        data={this.state.projectDepartments}
                                        textField="Name"
                                        dataItemKey="id"
                                        value={this.state.selectedProjectDepartments}
                                        onChange={this.handleInputChange}
                                        name="selectedProjectDepartments"
                                        placeholder={'Please Select'}
                                        filterable={true}
                                        onFilterChange={this.filterProjectDepartments}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="d-block">
                                <label>Engagement Type:</label>
                            </div>
                            <div className="d-block">
                                <div className="">
                                    <MultiSelect
                                        data={this.state.projectTypes}
                                        textField="Name"
                                        dataItemKey="id"
                                        value={this.state.selectedProjectType}
                                        onChange={this.handleInputChange}
                                        name="selectedProjectType"
                                        placeholder={'Please Select'}
                                        filterable={true}
                                        onFilterChange={this.filterProjectTypes}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div className="d-block">
                                <label>Billing Method:</label>
                            </div>
                            <div className="d-block">
                                <div className="">
                                    <MultiSelect
                                        data={this.state.paymentMethods}
                                        textField="Name"
                                        dataItemKey="id"
                                        value={this.state.selectedPaymentMethod}
                                        onChange={this.handleInputChange}
                                        name="selectedPaymentMethod"
                                        placeholder={'Please Select'}
                                        filterable={true}
                                        onFilterChange={this.filterPaymentMethod}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-12 btn-align-right">
                        <Button primary={true} type="submit" onClick={this.submitSearch}>
                            Search
                        </Button>
                        <Button type="button" onClick={this.cancelSearch}>
                            Clear
                        </Button>
                        </div>
                    </div>

                </form>

                <div className="main-seperator" />

                <div className="row">
                    <div className="col-md-6">
                        <div className="main-heading">Search Results</div>
                    </div>
                    <div className="col-md-6">
                        <div className="btn-align-right">
                            <Button primary className="pull-left" onClick={this.exportExcel} disabled={this.state.generateBtnDisable}>
                                {'Export to Excel'}
                            </Button>
                            {!this.state.loading && (
                                <DeliveryTrackerExcel
                                    deliveryTrackerData={this.state.deliveryTrackerDataExcel}
                                    reportDate={this.state.reportDate}
                                    updateData={this.state.excelDownload}
                                    StartDate = {moment(this.state.startDate).format('YYYY-MM-DD')}
                                    EndDate = {moment(this.state.endDate).format('YYYY-MM-DD')}
                                    dataUpdated={() => {
                                        this.setState({ excelDownload: false });
                                        const auditTrail = {
                                            Action: 'Delivery Tracker downloaded',
                                            RefType: 'Delivery Tracker',
                                            RefId: window.LOGGED_USER.user,
                                            RefName: window.LOGGED_USER.displayName
                                        }
                                        saveAuditTrail(auditTrail)
                                    }}
                                />
                            )}
                        </div>
                    </div> 
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Grid
                            data={orderBy(this.state.deliveryTrackerData, this.state.sort).slice(
                                this.state.skip,
                                this.state.take + this.state.skip
                            )}
                            className="delivery-tracker-grid" 
                            skip={this.state.skip}
                            take={this.state.take}
                            total={this.state.deliveryTrackerData.length}
                            pageable={true}
                            onPageChange={this.pageChange}
                            resizable
                            sortable={true}
                            sort={this.state.sort}
                            onSortChange={(e) => {
                                this.setState({
                                    sort: e.sort
                                });
                                }
                            }
                            style={this.state.deliveryTrackerData && this.state.deliveryTrackerData.length > 10 ? { height: '500px' } : ''}
                        >
                            <Column 
                                field="ProjectRegion" 
                                title="Region" 
                                width="80px"
                                footerCell={() => {
                                    return <td>{"Total"}</td>;
                                }}
                            />
                            <Column 
                                field="Customer" 
                                title="Customer" 
                                width="120px"
                            />
                            <Column 
                                field="ProjectName" 
                                title="Project Name" 
                                width="140px"
                            />
                             <Column 
                                field="OPID" 
                                title="OPID" 
                                width="75px"
                            />                        
                            <Column field="Resource" title="Resource" width="130px"/>
                            <Column field="ProjectRole" title="Project Role" width="130px"/>
                            <Column title="Invoiced Revenue">
                                <Column 
                                    field="InvoicedEffortPct" 
                                    title="Effort %"
                                    width="100px"
                                    cell={props => this.customCellPct(props)}
                                />
                                <Column 
                                    field="InvoicedEffort" 
                                    title="Effort Days"
                                    width="100px"
                                    cell={props => this.customCell(props)}
                                    footerCell={() => {
                                        return <td style={{ textAlign: 'right' }}>{formatNumber(Number(this.state.invoicedTotalEffort))}</td>;
                                    }}
                                />
                                <Column 
                                    field="InvoicedRevenuePC" 
                                    title="Project Currency"
                                    width="110px"
                                    cell={props => this.customCell(props)}
                                    footerCell={() => {
                                        return <td style={{ textAlign: 'right' }}>{formatNumber(Number(this.state.invoicedRevenueTotalPC))}</td>;
                                    }}
                                />
                                <Column 
                                    field="InvoicedRevenueUSD" 
                                    title="USD"
                                    width="100px"
                                    cell={props => this.customCell(props)}
                                    footerCell={() => {
                                        return <td style={{ textAlign: 'right' }}>{formatNumber(Number(this.state.invoicedRevenueTotalUSD))}</td>;
                                    }}
                                />
                            </Column>
                            <Column title="Timesheet Revenue">
                                <Column 
                                    field="TimesheetEffortPct" 
                                    title="Effort %"
                                    width="100px"
                                    cell={props => this.customCellPct(props)}
                                />
                                <Column 
                                    field="TimesheetEffort" 
                                    title="Effort Days"
                                    width="100px"
                                    cell={props => this.customCell(props)}
                                    footerCell={() => {
                                        return <td style={{ textAlign: 'right' }}>{formatNumber(Number(this.state.timesheetTotalEffort))}</td>;
                                    }}
                                />
                                <Column 
                                    field="TimesheetRevenuePC" 
                                    title="Project Currency"
                                    width="110px"
                                    cell={props => this.customCell(props)}
                                    footerCell={() => {
                                        return <td style={{ textAlign: 'right' }}>{formatNumber(Number(this.state.timesheetRevenueTotalPC))}</td>;
                                    }}
                                />
                                <Column 
                                    field="TimesheetRevenueUSD" 
                                    title="USD"
                                    width="100px"
                                    cell={props => this.customCell(props)}
                                    footerCell={() => {
                                        return <td style={{ textAlign: 'right' }}>{formatNumber(Number(this.state.timesheetRevenueTotalUSD))}</td>;
                                    }}
                                />
                            </Column>
                            <Column title="Allocation Revenue">
                                <Column 
                                    field="PlannedEffortPct" 
                                    title="Effort %"
                                    width="100px"
                                    cell={props => this.customCellPct(props)}
                                />
                                <Column 
                                    field="PlannedEffort" 
                                    title="Effort Days"
                                    width="100px"
                                    cell={props => this.customCell(props)}
                                    footerCell={() => {
                                        return <td style={{ textAlign: 'right' }}>{formatNumber(Number(this.state.plannedTotalEffort))}</td>;
                                    }}
                                />
                                <Column 
                                    field="PlannedRevenuePC" 
                                    title="Project Currency"
                                    width="110px"
                                    cell={props => this.customCell(props)}
                                    footerCell={() => {
                                        return <td style={{ textAlign: 'right' }}>{formatNumber(Number(this.state.plannedRevenueTotalPC))}</td>;
                                    }}
                                />
                                <Column 
                                    field="PlannedRevenueUSD" 
                                    title="USD"
                                    width="100px"
                                    cell={props => this.customCell(props)}
                                    footerCell={() => {
                                        return <td style={{ textAlign: 'right' }}>{formatNumber(Number(this.state.plannedRevenueTotalUSD))}</td>;
                                    }}
                                />
                            </Column>
                            <Column title="Daily Rate">
                                <Column field="DailyRateRegion" title="Project Currency" width="110px" className="profitability-grid-text-align"/>
                                <Column field="DailyRateUSD" title="USD" width="80px" className="profitability-grid-text-align"/>
                            </Column>
                            <Column field="BillingMethod" title="Billing Method" width="130px"/>
                            <Column field="ProjectDepartment" title="Project Department" width="130px"/>
                            <Column field="EngagementType" title="Engagement Type" width="130px"/>
                            <Column field="ProjectManager" title="Project Manager" width="130px"/>
                            <Column field="ResPractice" title="Resource Practice" width="130px"/>
                            <Column field="ProjectStatus" title="Project Status" width="100px"/>
                        </Grid>
                    </div>
                </div>
                <Loader loading={this.state.loading} />
            </div>
        );
    }
}   

export default DeliveryTracker;



